import { Directive, ElementRef, NgZone, NgModule } from '@angular/core';
import { merge, fromEvent } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/set-height.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class SetHeightDirective {
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     */
    constructor(elementRef, ngZone) {
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this.update = this.update.bind(this);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        setTimeout(this.update, 0);
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            this.resizeSubscription = merge(fromEvent(window, 'resize'), fromEvent(window, 'orientationchange'), fromEvent(window, 'load')).subscribe(this.update);
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.resizeSubscription && this.resizeSubscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    update() {
        /** @type {?} */
        const element = ((/** @type {?} */ (this.elementRef.nativeElement)));
        element.style.cssText += '; height: auto !important;';
        /** @type {?} */
        const height = element.offsetHeight;
        element.style.height = `${height}px`;
    }
}
SetHeightDirective.ɵfac = function SetHeightDirective_Factory(t) { return new (t || SetHeightDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
SetHeightDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SetHeightDirective, selectors: [["", "egovSetHeight", ""]] });
/** @nocollapse */
SetHeightDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SetHeightDirective, [{
        type: Directive,
        args: [{
                selector: '[egovSetHeight]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    SetHeightDirective.prototype.resizeSubscription;
    /**
     * @type {?}
     * @private
     */
    SetHeightDirective.prototype.elementRef;
    /**
     * @type {?}
     * @private
     */
    SetHeightDirective.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/set-height.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SetHeightModule {
}
SetHeightModule.ɵfac = function SetHeightModule_Factory(t) { return new (t || SetHeightModule)(); };
SetHeightModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SetHeightModule });
SetHeightModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SetHeightModule, [{
        type: NgModule,
        args: [{
                declarations: [SetHeightDirective],
                exports: [SetHeightDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SetHeightModule, { declarations: [SetHeightDirective], exports: [SetHeightDirective] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-set-height.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { SetHeightModule, SetHeightDirective as ɵa };

